import React, { useEffect, useMemo, useState } from 'react';
import { KChatService } from 'kn-chat-app';
import { HttpClient as API } from '../Api/httpClient';
import { get } from 'lodash';
import { getCookie, cookieNames } from '../util';

const WithChatService = (Component) => {
  const EnhancedComponent = (props) => {
    const [kxUser, setKxUser] = useState(null);

    const userToken = getCookie(cookieNames.KxCommon);

    const envUrls = useMemo(
      () => ({
        API_URL: window._env_.REACT_APP_API_URL,
        DOCUMENT_URL: window._env_.REACT_APP_MEDIA_URL,
        CHAT_APP_URL: `wss://${window._env_.REACT_APP_CHAT_SOCKET_URL}`,
        CHAT_DOCUMENT_BUCKET: window._env_.CHAT_DOCUMENT_BUCKET,
      }),
      []
    );

    useEffect(() => {
      const getUserDetails = () => {
        API.getKxuser(userToken)
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            setKxUser(get(res, 'eventMessage.userBasicInfo', null));
          })
          .catch((err) => {
            console.error(err);
          });
      };

      if (userToken) {
        getUserDetails();
      }
    }, [userToken]);
    
    if (userToken) {
      return (
        <KChatService
          token={userToken}
          userGuid={get(kxUser, 'userGuid', '')}
          envUrls={envUrls}
          platformDetails={{ is360: true }}
        >
          <Component {...props} />
        </KChatService>
      );
    } else {
      return <Component {...props} />;
    }
  };
  return EnhancedComponent;
};

export default WithChatService;
